angular.module('dnecom')
    .directive('summernote', ["$http", "Upload", "notifications", "MediaSrc", function ($http, Upload, notifications, MediaSrc) {
        return {
            scope: {
                'summernoteOptions': '=',
                'summernoteTemplates': '=?',
                'storeId': '='
            },
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {
                var templates = [];

                var defaultOptions = {
                    toolbar: [
                        ['general', [
                            'style', 'bold', 'italic', 'underline', 'strikethrough', 'clear', 'fontname',
                            'fontsize', 'color', 'ul', 'ol', 'paragraph', 'lineheight', 'table', 'link', 'picture', 'emoji',
                            'video', 'hr', 'codeview', 'help'
                        ]]
                    ],
                    popover: {
                        image: [
                            ['imagesize', ['imageSize100', 'imageSize50', 'imageSize25']],
                            ['float', ['floatLeft', 'floatRight', 'floatNone']],
                            ['remove', ['removeMedia']]
                        ]
                    },
                    lang: 'en-US',
                    imageAttributes: {
                        icon: '<i class="fa fa-edit"/>', // This Icon is from the LibreICONS class Extras and SVG Icons for Summernote.
                        removeEmpty: false // true = remove attributes | false = leave empty if present
                    },
                    cleaner: {
                        action: 'paste', // both|button|paste 'button' only cleans via toolbar button, 'paste' only clean when pasting content, both does both options.
                        newline: '<p><br></p>', // Summernote's default is to use '<p><br></p>'
                        keepHtml: true, // Remove all Html formats
                        keepOnlyTags: [], // If keepHtml is true, remove all tags except these
                        keepClasses: false, // Remove Classes
                        badTags: ['style', 'script', 'applet', 'embed', 'noframes', 'noscript'], // Remove full tags with contents
                        badAttributes: ['start'] // Remove attributes from remaining tags
                    },
                    callbacks: {
                        onFocus: function (e) {
                            $(e.currentTarget).parents('.note-editor').removeClass('with-modal');
                        },
                        onBlur: function (e) {
                            if ($('.note-editor .modal.in').length) {
                                $(e.currentTarget).parents('.note-editor').addClass('with-modal');
                            }
                        },
                        onImageUpload: function(image) {
                            uploadImage(image[0]);
                        }
                    }
                };

                function uploadImage(image) {
                    Upload.upload({
                        url: Routing.generate('upload_file', {store: scope.storeId}),
                        data: {
                            file: image
                        }
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            var imagePath = MediaSrc.src(response.data.media);
                            var image = $('<img>').attr('src', imagePath);
                            scope.editor.summernote("insertNode", image[0]);
                        } else {
                            notifications.danger(response.data.message);
                        }
                    }, function () {
                        notifications.danger('There was a problem with image uploading.');
                    });
                };

                // Init template button
                if (!_.isUndefined(scope.summernoteTemplates)) {
                    // Generate dropdown items
                    var listItemTemplate = '<li data-template-index="%INDEX%"><a tabindex><strong>%TITLE%</strong></a></li>', listItems = '';
                    angular.forEach(scope.summernoteTemplates, function (item, index) {
                        listItems += listItemTemplate.replace('%TITLE%', item.title).replace('%INDEX%', index);
                        templates[index] = item.content;
                    });

                    // Create button
                    var templateDropdown = function (context) {
                        var ui = $.summernote.ui;

                        return ui.buttonGroup([
                            ui.button({
                                className: 'dropdown-toggle btn-success',
                                contents: '<span class="fa fa-fw fa-file-text"></span> <span class="caret"></span>',
                                tooltip: 'Templates',
                                data: {
                                    toggle: 'dropdown'
                                }
                            }),
                            ui.dropdown({
                                className: 'dropdown-style',
                                contents: listItems,
                                callback: function ($dropdown) {
                                    $dropdown.find('li').each(function () {
                                        $(this).click(function () {
                                            element.summernote('reset');
                                            context.invoke('editor.pasteHTML', templates[$(this).data('template-index')]);
                                        });
                                    });
                                }
                            })
                        ]).render();
                    };

                    // Add button to options
                    defaultOptions.toolbar[0][1].unshift('templates');
                    defaultOptions.buttons = {
                        templates: templateDropdown
                    };
                }

                // Init smile hint
                defaultOptions.hint = {
                    match: /:([\-+\w]+)$/,
                    search: function (keyword, callback) {
                        var myCallback = $.grep(window.emojis, function (item) {
                            return item.indexOf(keyword)  === 0;
                        });

                        // Reuse already loaded emojis from other emoji plugins if exist
                        if (_.isUndefined(window.emojis) && _.isUndefined(window.emojiUrls)) {
                            $http.get('https://api.github.com/emojis')
                                .then(function (result) {
                                    window.emojis = Object.keys(result.data);
                                    window.emojiUrls = result.data;
                                    callback(myCallback);
                                }, function (error) {
                                    console.error('Custom emoji hint plugin: ' + error);
                                });
                        } else {
                            callback(myCallback);
                        }
                    },
                    template: function (item) {
                        return '<img src="' + window.emojiUrls[item] + '" /> :' + item + ':';
                    },
                    content: function (item) {
                        var url = window.emojiUrls[item];

                        if (url) {
                            return $('<img />').attr('src', url).addClass('inline').addClass('emoji-img-inline')[0];
                        } else {
                            return '';
                        }
                    }
                };

                // Init summernote
                var options = angular.extend(defaultOptions, scope.summernoteOptions);

                element.wrap('<div class="summernote-wrapper"></div>');
                scope.editor = element.summernote(options);
                element.summernote('removeModule', 'autoLink');

                scope.$on('$destroy', function () {
                    element.summernote('destroy');
                });

                ngModelController.$render = function () {
                    element.summernote('code', ngModelController.$viewValue);
                };

                element.on('summernote.change', function (ws, contents) {
                    ngModelController.$setViewValue(contents);
                });
            }
        }
    }]);
